var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStakeAction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 20.5C6.5 20.5 8.5 19 12 19C15.5 19 17.5 20.5 17.5 20.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9954 18.9999L12.0027 15.9989M12.0027 13.6117C12.0027 12.2819 11.1159 9.62283 8.97291 8.38626C7.26802 7.40249 5.52583 7.65882 4.375 7.77294C4.375 10.1509 4.8124 12.2332 6.64237 13.5263C8.72699 14.9993 10.9462 14.3258 12.0027 15.9989M12.0027 13.6117V15.9989M12.0027 13.6117C12.0027 13.1275 11.7878 12.2486 11.7878 12.2486C11.6198 11.729 11.5031 11.2084 11.4558 10.68C11.2202 8.04762 12.0027 5.24598 14.758 3.63842C17.1054 2.2688 19.0733 2.4945 20.3018 2.6185C20.6147 4.50286 20.6215 6.85269 18.657 9.02048C16.3932 11.5185 15.3918 11.3362 13.0606 13.0506C12.2976 13.6117 12.0931 14.1794 12.0027 14.5825C12.0027 14.5825 12.0027 14.3855 12.0027 13.6117Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeAction);
export default __webpack_public_path__ + "static/media/stake-action.d7d18ddd28f29e798dbbc4e7996529f2.svg";
export { ForwardRef as ReactComponent };